import React from 'react';
import './MobileHeader.css';

function MobileHeader({
  showClose,
  setShowClose,
  setSelectedPage,
  selectedPage,
  setShowAbout,
  setShowDetails,
  setShowContactInformation,
  showDetails,
  showAbout,
  showImprint,
  setShowImprint,
}) {
  const handleArchiveClick = () => {
    setSelectedPage(0);
  };

  const handleTypefacesClick = () => {
    setSelectedPage(1);
  };

  const handleCloseClick = () => {
    setShowClose(false);
    setShowDetails(false);
    setShowAbout(false);
    setShowContactInformation(false);
    setShowImprint(false);
  };

  const handleAboutClick = () => {
    setShowAbout(true);
    setShowContactInformation(false);
    setShowDetails(false);
    setShowImprint(false);
  };

  const handleImprintClick = () => {
    setShowImprint(!showImprint);
  };

  return (
    <div className="mobile-header p-4">
      {!showClose && !showAbout && (
        <React.Fragment>
          <button
            className={`mobile-header-button`}
            onClick={handleAboutClick}
          >
            ABOUT
          </button>
          <button
            className={`mobile-header-button ${selectedPage === 0 && !showClose && !showDetails ? 'selected' : ''}`}
            onClick={handleArchiveClick}
            style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}
          >
            ARCHIVE
          </button>
          <button
            className={`mobile-header-button ${selectedPage === 1 && !showClose && !showDetails ? 'selected' : ''}`}
            onClick={handleTypefacesClick}
          >
            TYPEFACES
          </button>
        </React.Fragment>
      )}
      {showAbout && (
        <React.Fragment>
          <button
            className="mobile-header-button selected" style={{ position: 'relative', zIndex: 3, opacity: showImprint ? 0 : 1 }}
            onClick={handleCloseClick}
          >
            CLOSE
          </button>
          <button
            className={`mobile-header-button ${showImprint ? 'selected' : ''}`} 
            style={{ position: 'relative', zIndex: 3 }}
            onClick={handleImprintClick}
          >
            {showImprint ? 'CLOSE' : 'IMPRINT'}
          </button>
        </React.Fragment>
      )}
    </div>
  );
}

export default MobileHeader;
